import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=7ab6e572&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=7ab6e572&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab6e572",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ab6e572')) {
      api.createRecord('7ab6e572', component.options)
    } else {
      api.reload('7ab6e572', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=7ab6e572&scoped=true", function () {
      api.rerender('7ab6e572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaTabs/Tabs.vue"
export default component.exports